import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/_dashboard/recurring-invoices/')({
  beforeLoad: () => {
    throw redirect({ to: '/invoices', replace: true })
  },
})
